import React from "react";
import { useAuth0 } from "./react-auth0-wrapper";
import { Link } from "react-router-dom";
import Loading from './Loading.js';


/*
JSON.stringify(user, null, 2)
{ "nickname": "matt.biehl", "name": "matt.biehl@web.de", "picture": "https://s.gravatar.com/avatar/39e21d6f4cb448b10d5fcdd1fd4aca04?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fma.png", "updated_at": "2019-07-31T11:39:38.013Z", "email": "matt.biehl@web.de", "email_verified": false, "sub": "auth0|5d413da25025330cc04ae80f" }
*/
const NavBar = () => {

  const { loading, isAuthenticated, loginWithRedirect, logout, user } = useAuth0();
  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      {!isAuthenticated  && (
        <span>
          <a id="LogInLink" title="log in" href="#" onClick={() => {loginWithRedirect(); return false; }}>login &amp; signup</a>
        </span>
      )}

      {isAuthenticated && user && (
      <span>Hi {user.name}&nbsp;&nbsp;<img height="14px" src={user.picture} alt="Profile" /><br/>
        <span>
          <a href={`https://auth.truelayer.com/?response_type=code&client_id=myapp-89188a&nonce=3110072229&state=${encodeURIComponent(user.sub)}&scope=info%20accounts%20balance%20cards%20transactions%20direct_debits%20standing_orders%20products%20beneficiaries%20offline_access&redirect_uri=https://api.api-university.com/v1/callback&enable_mock=true&enable_oauth_providers=true&enable_open_banking_providers=true&enable_credentials_sharing_providers=false`}>
            add account 
          </a>&nbsp;
          <Link to="/accounts">accounts</Link>&nbsp;
          <Link to="/transactions">transactions</Link>&nbsp;
          <Link to="/analysis">analysis</Link>&nbsp;
          <a id="LogOutLink" title="log out" href="#" onClick={() => {logout({returnTo:"https://bank.api-university.com",client_id:"zSykOLKS95wO01inWzOLdZ6xpTOWPrLM"}); return false; }}>logout</a>
        </span>
      </span>
      )}
    </div>
  );
};

export default NavBar;




// WEBPACK FOOTER //
// ./src/NavBar.js